import gam1 from '../../Resources/services/icons/icon-gamificacion.svg'
import gam2 from '../../Resources/services/icons/icon-produccion-integral.svg'
import gam3 from '../../Resources/services/icons/icon-lideres-en-trivia.svg'

import ig1 from '../../Resources/services/icons/icon-mindset.svg'
import ig2 from '../../Resources/services/icons/icon-audiencias.svg'
import ig3 from '../../Resources/services/icons/icon-brand-safety.svg'
import SvcTemplate from "./SvcTemplate";
import PServicesIGAContent from "../Portrait/pServicesIGAContent.js";
import c11 from "../../Resources/logos/Logo-sega copy.png";
import c12 from "../../Resources/logos/Logo-rovio copy.png";
import c13 from "../../Resources/logos/Logo-ironsource copy.png";
import c14 from "../../Resources/logos/Logo-Jamcity.png";
import c21 from "../../Resources/logos/Logo-Kwalee.png";
import c22 from "../../Resources/logos/Logo-outfit copy.png";
import c23 from "../../Resources/logos/Logo-Atari.png";
import c24 from "../../Resources/logos/Google Marketing Platform copy.png";
import c31 from "../../Resources/logos/Logo-smar+ copy.png";
import c32 from "../../Resources/logos/Logo-ubisoft.png";
import c33 from "../../Resources/logos/Logo-Xandr copy.png";
import c34 from "../../Resources/logos/Logo-anzu copy.png";
import React from "react";
import {getFM, getSpan, isPortrait, ScrollSnap} from "../../Utilities/utils";
import MaxFooter from "../Footer";
import MaxButton from "../MaxButton";
import {logEvent} from "../../Utilities/AmplitudeService";

const pfx = 'services';
const title = 'title';
const text = 'text';

function GetKeys(msg: string[], id: string, sfx: string): string[] {
    let msgId = `${pfx}_${id}_${sfx}`;

    if (isPortrait()) {
        const p_msgId = 'p' + msgId;
        if (msg[p_msgId]) {
            msgId = p_msgId;
        }
    }

    let res = [msgId];
    if (msg[msgId + '_2']) {
        res.push(msgId + '_2');
    }
    if (msg[msgId + '_3']) {
        res.push(msgId + '_3');
    }
    return res;
}

function getSlide(msg: string[], id: string, p: string, ico: any | undefined) {
    return {
        title: GetKeys(msg, id, `${p}_${title}`),
        subTitle: GetKeys(msg, id, `${p}_${text}`),
        header: ico ?
            <img className={'svc-icon'} src={ico} alt={'alt'}/>
            :
            <div className={'svc-header svc-slide-title big-title'}>
                {getSpan(GetKeys(msg, id, `${p}_figure`))}
            </div>
    };
}

export function SvcIngame(props, msg: string[]) {
    const id = 'IGA';
    logEvent(`${id}_loaded`);

    function getCard(idx, ch) {
        return {
            title: `${pfx}_${id}_format${idx}`,
            stats: `${pfx}_${id}_format${idx}_metric`,
            subtitle: `${pfx}_${id}_format${idx}_description`,
            child: ch ? ch : <></>,
            index: idx,
            format: "format" + idx
        };
    }

    const cards = [
        getCard(1),
        getCard(2),
        getCard(3,
            <MaxButton width={'16vw'} clickEvent={() => {
                logEvent('showcase_clicked')
                window.open("https://showcase.etermax.com", "_blank")
            }}>
                {`${pfx}_${id}_showcase_button`}
            </MaxButton>),
        getCard(4),
        getCard(5)
    ];

    function getIngameContent() {
        logEvent('In_game_loaded')
        isPortrait() && ScrollSnap()
        console.log(props.mainText)
        return <>
            <div className={"svc-partners-content"}>

                <div className="svc-partners-content-header">
                    <div className={'svc-partners-left-container svc-subtitle'}>
                        <div className={'svc-title-header'}
                             style={{margin: 'auto 0'}}>
                            {getSpan(['services_IGA_partners'])}
                        </div>

                        <div style={{margin: 'auto'}}>
                            {getSpan(['services_IGA_partners_text',
                                'services_IGA_partners_text_2'])}
                        </div>
                    </div>
                    <div className={"svc-partners"}>
                        <img src={c11} className={"partners"} alt={'Partner'}/>
                        <img src={c12} className={"partners"} alt={'Partner'}/>
                        <img src={c13} className={"partners"} alt={'Partner'}/>
                        <img src={c14} className={"partners"} alt={'Partner'}/>
                        <img src={c21} className={"partners"} alt={'Partner'}/>
                        <img src={c22} className={"partners"} alt={'Partner'}/>
                        <img src={c23} className={"partners"} alt={'Partner'}/>
                        <img src={c24} className={"partners"} alt={'Partner'}/>
                        <img src={c31} className={"partners"} alt={'Partner'}/>
                        <img src={c32} className={"partners"} alt={'Partner'}/>
                        <img src={c33} className={"partners"} alt={'Partner'}/>
                        <img src={c34} className={"partners"} alt={'Partner'}/>
                    </div>
                </div>
            </div>
            <div className={"svc-formatos-content"}>
                {
                    cards.map((value, index) => {
                        return <div className={"iga-panel"} key={"panel" + index}>
                            <section className={"iga-panel-section"}>
                                <section>
                                    <span className={'emboss-text iga-bigfont'}>0{index + 1}</span>
                                    <span className={'iga-title iga-bigfont'}>
                    {getFM(value.title)}
                        </span>
                                    <div className={'divider'}/>
                                </section>
                                <span className={"iga-stats title-text"}>
                    {getFM(value.stats)}
                        </span>
                                {value.child}
                            </section>
                            <span className={'iga-subtitle font-subtitle'}>
                    {getFM(value.subtitle)}
                        </span>
                        </div>
                    })}
            </div>
            <MaxFooter className={'svc-footer'}/>
        </>;
    }

    return (<SvcTemplate id={id}
                         mainText={GetKeys(msg, id, title)}
                         contentText={GetKeys(msg, id, text)}
                         slides={[getSlide(msg, id, 'point1', ig1),
                             getSlide(msg, id, 'point2', ig2),
                             getSlide(msg, id, 'point3', ig3)]}>
            {isPortrait() ?
                <PServicesIGAContent cards={cards}/>
                : getIngameContent()}
        </SvcTemplate>
    );
};

export const SvcGaming = (props, msg: string[]) => {
    const id = 'gaming';
    logEvent(`${id}_loaded`);

    return (<SvcTemplate id={id}
                         mainText={GetKeys(msg, id, title)}
                         contentText={GetKeys(msg, id, text)}
                         slides={[getSlide(msg, id, 'point1', gam1),
                             getSlide(msg, id, 'point2', gam2),
                             getSlide(msg, id, 'point3', gam3)]}>
    </SvcTemplate>);
};

export const SvcConsulting = (props, msg: string[]) => {
    const id = 'consulting';
    logEvent(`${id}_loaded`);

    return (<SvcTemplate id={id}
                         mainText={GetKeys(msg, id, title)}
                         contentText={GetKeys(msg, id, text)}
                         slides={[getSlide(msg, id, 'point1'),
                             getSlide(msg, id, 'point2'),
                             getSlide(msg, id, 'point3')]}>
    </SvcTemplate>);
};

export const SvcEsports = (props, msg: string[]) => {
    const id = 'esports';
    logEvent(`${id}_loaded`);

    return (<SvcTemplate id={id}
                         mainText={GetKeys(msg, id, title)}
                         contentText={GetKeys(msg, id, text)}
                         slides={[getSlide(msg, id, 'point1'),
                             getSlide(msg, id, 'point2'),
                             getSlide(msg, id, 'point3')]}>
    </SvcTemplate>);
}
